var render, staticRenderFns
import script from "./log_table.vue?vue&type=script&lang=js"
export * from "./log_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d2ae93e')) {
      api.createRecord('9d2ae93e', component.options)
    } else {
      api.reload('9d2ae93e', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/district_area_update_and_adjust/form/log_table.vue"
export default component.exports